import { Vault } from '@/features/vaults/types';
import { Hash } from '@/shared/types/Hash';
import { mezoBtcTokenAddress } from '@/features/vaults/constants/vaults/mezo/tokens/mezoBtcTokenAddress';
import { mezoBtcPreDepositVaultAddress } from '@/features/vaults/constants/vaults/mezo/mezo-btc-vault-on-ethereum';

export const mezoBtcPreDepositVaultId = 'mezo-btc-vault';

export const mezoBtcVaultAddress: Hash = '0x807D4778abA870e4222904f5b528F68B350cE0E0';

export const mezoBtcVault: Vault = {
  migrations: [
    {
      network: 'ethereum',
      address: mezoBtcPreDepositVaultAddress,
      id: mezoBtcPreDepositVaultId,
    },
  ],
  id: mezoBtcPreDepositVaultId,
  type: 'core-vault',
  category: 'core-vault',
  name: 'Mezo BTC Vault',
  description:
    'Bring It Home to Mezo with Highest BTC Yield onchain this season. Curated Bitcoin yield vault by Sense.capital. Deposits are deployed into onchain liquidity strategies like Mezo Tigris, Uniswap V4, Curve and Yield Basis.\n' +
    '<br /><br />' +
    'Curator: Sense Capital — Quantitative fund specializing in institutional-grade DeFi strategies. Focus on IL-minimized, full-reserve, diversified yield across blue-chip venues',
  address: mezoBtcVaultAddress,
  network: 'mezo',
  networks: [
    {
      network: 'mezo',
      vaultAddress: mezoBtcVaultAddress,
    },
  ],
  curators: ['mezo', 'sense'],
  operator: [],
  baseToken: mezoBtcTokenAddress,
  depositTokens: [
    {
      address: mezoBtcTokenAddress,
      decimals: 18,
      symbol: 'BTC',
    },
  ],
  points: [{ entity: 'mellow', startTimestamp: 1760967575 }],
  lpTokenSymbol: 'mbhBTC',
  lpTokenDecimals: 18,
  allocations: {
    showAllocationsTab: false,
  },
  oracleUpdateInterval: BigInt(86400),
  redeemHandlingInterval: BigInt(3600),
  isInstantDeposit: true,
};
